import { Link, useParams } from "react-router-dom";

import { useE2EAgentAdminRun } from "../api/admin";
import { hideChatAndFastTrack } from "../lib/featureFlags";
import AdminRunEvidence from "./AdminRunEvidence";
import { RunStatusTag } from "./ui";
import { PageHeader } from "./WorkspacePrimitives";

export default function E2EAgentRunDetailPage() {
  const restrictedProductionUi = hideChatAndFastTrack();
  const { runId = "" } = useParams<{ runId: string }>();
  const query = useE2EAgentAdminRun(runId);
  if (query.isLoading && !query.data)
    return <div className="state">Loading E2E agent run…</div>;
  if (query.error && !query.data)
    return (
      <div className="state err">Failed to load run: {query.error.message}</div>
    );
  const run = query.data;
  if (!run) return null;
  const status =
    run.state.kind === "terminal" ? run.state.outcome : run.state.kind;
  return (
    <section className="build-detail-page e2e-admin-detail">
      <PageHeader className="e2e-admin-detail-header">
        <Link className="back-link" to="/admin/runs">
          ← E2E agent fleet
        </Link>
        <div className="build-detail-hero">
          <div>
            <span className="section-kicker">
              Standalone E2E run · {run.id}
            </span>
            <h2>
              {run.ticker} · {run.company_name}
            </h2>
            <p>
              {run.country} · {run.parameters.input_mode}
              {!restrictedProductionUi &&
                ` · ${run.parameters.fast ? "fast" : "standard"}`}
            </p>
            <p>Hypothesis: {run.hypothesis}</p>
          </div>
          <RunStatusTag status={status}>{status}</RunStatusTag>
        </div>
      </PageHeader>

      {run.state.kind === "terminal" &&
        run.state.outcome === "failed" &&
        run.state.failure && (
          <div className="build-detail-alert">
            <strong>{run.state.failure.safe_message}</strong>
            <span>
              {run.state.failure.phase} · {run.state.failure.category} ·{" "}
              {run.state.failure.code}
            </span>
          </div>
        )}

      <AdminRunEvidence runId={runId} />
    </section>
  );
}
